/*
  Teilen – Produktseite und Warenkorb (Styles: cx-refresh.css, Abschnitt „Teilen“).

  Produktseite (snippets/cx-share.liquid, Button [data-cx-share="product"]):
    Teilt GENAU die gewählte Variante: https://luxusbetten24.de/products/<handle>?variant=<id>.
    Variant-ID: 1) Theme-Event „variant:change“ (theme.js, bubbelt vom Produktformular; detail.variant.id)
                2) sonst das [name="id"]-Feld des Produktformulars (data-form)
                3) sonst ?variant= aus der URL bzw. data-variant (Server-Stand).
    Das Theme aktualisiert die URL beim Variantenwechsel NICHT (replaceState ist auskommentiert),
    deshalb wird die ID nie aus location.href allein gelesen.

  Warenkorb (/cart): Button „Warenkorb teilen“ wird per JS unter den Checkout-Button gesetzt
    (sections/main-cart.liquid bleibt unangetastet). Link = Shopify-Cart-Permalink
    https://luxusbetten24.de/cart/<variantId>:<qty>,<variantId>:<qty> – nur Positionen OHNE
    line item properties; konfigurierte Artikel (Konfigurator) lassen sich so nicht übergeben.

  Mit navigator.share: natives Share-Sheet. Sonst Popover: WhatsApp, Link kopieren, E-Mail.
*/
(function () {
  'use strict';

  var ORIGIN = 'https://luxusbetten24.de';
  var SHOP_NAME = 'Luxusbetten24';

  /* ---------------- Hilfen ---------------- */

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var ICONS = {
    whatsapp: '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.86 9.86 0 0 0 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2m0 1.67c2.2 0 4.26.86 5.82 2.42a8.2 8.2 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23-1.48 0-2.93-.39-4.19-1.15l-.3-.17-3.12.82.83-3.04-.2-.32a8.2 8.2 0 0 1-1.26-4.38c.01-4.54 3.7-8.24 8.25-8.24M8.53 7.33c-.16 0-.43.06-.66.31-.22.25-.87.86-.87 2.07 0 1.22.89 2.39 1 2.56.14.17 1.76 2.67 4.25 3.73.59.27 1.05.42 1.41.53.59.19 1.13.16 1.56.1.48-.07 1.46-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.07-.1-.23-.16-.48-.27-.25-.14-1.47-.74-1.69-.82-.23-.08-.37-.12-.56.12-.16.25-.64.81-.78.97-.15.17-.29.19-.53.07-.26-.13-1.06-.39-2-1.23-.74-.66-1.23-1.47-1.38-1.72-.12-.24-.01-.39.11-.5.11-.11.27-.29.37-.44.13-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.11-.56-1.35-.77-1.84-.2-.48-.4-.42-.56-.43-.14 0-.3-.01-.47-.01"/></svg>',
    link: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>',
    mail: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>',
    check: '<svg viewBox="0 0 20 20" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 10.5l4 4 8-9"/></svg>'
  };

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).catch(function () { return copyLegacy(text); });
    }
    return Promise.resolve(copyLegacy(text));
  }

  function copyLegacy(text) {
    var ta = el('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:fixed;top:-1000px;left:-1000px;opacity:0';
    document.body.appendChild(ta);
    ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    ta.remove();
    if (!ok) throw new Error('copy failed');
  }

  var toastTimer;
  function toast(msg) {
    var old = document.querySelector('.cx-share-toast');
    if (old) old.remove();
    var t = el('div', 'cx-share-toast', '<span class="cx-share-toast__icon">' + ICONS.check + '</span><span>' + esc(msg) + '</span>');
    t.setAttribute('role', 'status');
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      t.classList.remove('is-in');
      setTimeout(function () { t.remove(); }, 300);
    }, 2200);
  }

  /* ---------------- Popover ---------------- */

  var pop = null, popOwner = null;

  function closePopover() {
    if (!pop) return;
    pop.remove();
    pop = null;
    if (popOwner) popOwner.setAttribute('aria-expanded', 'false');
    popOwner = null;
    document.removeEventListener('click', onDocClick, true);
    document.removeEventListener('keydown', onKey);
    window.removeEventListener('resize', position);
    window.removeEventListener('scroll', position, true);
  }

  function onDocClick(e) {
    if (pop && !pop.contains(e.target) && !(popOwner && popOwner.contains(e.target))) closePopover();
  }

  function onKey(e) {
    if (e.key === 'Escape') { closePopover(); if (popOwner) popOwner.focus(); }
  }

  function position() {
    if (!pop || !popOwner) return;
    if (window.matchMedia('(max-width: 699px)').matches) {
      pop.style.top = pop.style.left = pop.style.right = '';
      return;
    }
    var r = popOwner.getBoundingClientRect();
    var w = pop.offsetWidth, h = pop.offsetHeight;
    var left = Math.min(Math.max(12, r.left), window.innerWidth - w - 12);
    var top = r.bottom + 8;
    if (top + h > window.innerHeight - 12) top = Math.max(12, r.top - h - 8);
    pop.style.left = left + 'px';
    pop.style.top = top + 'px';
  }

  /* data: { heading, title, url, text, note } */
  function openPopover(owner, data) {
    closePopover();
    popOwner = owner;
    owner.setAttribute('aria-expanded', 'true');
    pop = el('div', 'cx-share-pop');
    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-label', data.heading || 'Teilen');

    var shareText = data.text || data.title;
    var html = '<div class="cx-share-pop__head"><span class="cx-share-pop__heading">' + esc(data.heading || 'Teilen') + '</span>' +
      '<button type="button" class="cx-share-pop__close" aria-label="Schließen">&times;</button></div>';
    if (data.title) html += '<p class="cx-share-pop__title">' + esc(data.title) + '</p>';
    if (data.url) {
      html += '<ul class="cx-share-pop__list" role="list">' +
        '<li><a class="cx-share-pop__item" target="_blank" rel="noopener" href="https://wa.me/?text=' + encodeURIComponent(shareText + '\n' + data.url) + '">' + ICONS.whatsapp + '<span>WhatsApp</span></a></li>' +
        '<li><button type="button" class="cx-share-pop__item" data-cx-copy>' + ICONS.link + '<span>Link kopieren</span></button></li>' +
        '<li><a class="cx-share-pop__item" href="mailto:?subject=' + encodeURIComponent(data.title) + '&body=' + encodeURIComponent(shareText + '\n\n' + data.url) + '">' + ICONS.mail + '<span>E-Mail</span></a></li>' +
        '</ul>' +
        '<div class="cx-share-pop__url"><input type="text" readonly value="' + esc(data.url) + '" aria-label="Link"></div>';
    }
    if (data.note) html += '<p class="cx-share-pop__note">' + esc(data.note) + '</p>';
    pop.innerHTML = html;
    document.body.appendChild(pop);

    pop.querySelector('.cx-share-pop__close').addEventListener('click', closePopover);
    var copyBtn = pop.querySelector('[data-cx-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        copyText(data.url).then(function () { toast('Link kopiert'); closePopover(); })
          .catch(function () { var inp = pop && pop.querySelector('input'); if (inp) { inp.focus(); inp.select(); } });
      });
    }
    var inp = pop.querySelector('input');
    if (inp) inp.addEventListener('focus', function () { inp.select(); });

    position();
    requestAnimationFrame(function () { if (pop) { pop.classList.add('is-in'); position(); } });
    setTimeout(function () {
      document.addEventListener('click', onDocClick, true);
      document.addEventListener('keydown', onKey);
      window.addEventListener('resize', position);
      window.addEventListener('scroll', position, true);
    }, 0);
    var first = pop.querySelector('.cx-share-pop__item, .cx-share-pop__close');
    if (first) first.focus({ preventScroll: true });
  }

  /* Natives Share-Sheet, sonst Popover. Abbruch durch den Nutzer bleibt stumm. */
  function share(owner, data) {
    if (navigator.share && data.url) {
      var payload = { title: data.title, text: data.text || data.title, url: data.url };
      try {
        if (navigator.canShare && !navigator.canShare(payload)) return openPopover(owner, data);
      } catch (e) { /* weiter */ }
      navigator.share(payload).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        openPopover(owner, data);
      });
      return;
    }
    openPopover(owner, data);
  }

  /* ---------------- Produktseite ---------------- */

  function initProduct(btn) {
    var variants = {};
    try { variants = JSON.parse(btn.getAttribute('data-variants') || '{}'); } catch (e) { variants = {}; }
    var current = btn.getAttribute('data-variant') || '';
    var fromUrl = new URL(location.href).searchParams.get('variant');
    if (fromUrl && variants[fromUrl]) current = fromUrl;

    function readForm() {
      var form = document.getElementById(btn.getAttribute('data-form') || '');
      if (!form) return null;
      var field = form.querySelector('[name="id"]');
      return field && field.value ? String(field.value) : null;
    }

    function currentId() {
      var v = readForm();
      if (v && variants[v]) current = v;
      return current;
    }

    document.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v || !v.id) return;
      if (!e.target || !btn.getAttribute('data-form') || e.target.id === btn.getAttribute('data-form') || e.target.closest('#' + btn.getAttribute('data-form'))) {
        current = String(v.id);
        if (v.title && !variants[current]) variants[current] = v.title;
      }
    });

    btn.addEventListener('click', function () {
      if (pop && popOwner === btn) return closePopover();
      var id = currentId();
      var vt = variants[id];
      var title = btn.getAttribute('data-title') || document.title;
      if (vt && vt !== 'Default Title') title += ' – ' + vt;
      var url = ORIGIN + '/products/' + btn.getAttribute('data-handle') + (id ? '?variant=' + id : '');
      share(btn, { heading: 'Produkt teilen', title: title, text: title + ' | ' + SHOP_NAME, url: url });
    });
  }

  /* ---------------- Warenkorb ---------------- */

  var CART_NOTE = 'Konfigurierte Artikel können nicht geteilt werden – dafür gibt es im Konfigurator den eigenen Teilen-Link.';

  function cartShareData(cart) {
    var pairs = [], skipped = 0, count = 0;
    (cart.items || []).forEach(function (it) {
      var props = it.properties || {};
      var hasProps = Object.keys(props).some(function (k) { return props[k] !== null && props[k] !== '' && k.charAt(0) !== '_'; });
      if (hasProps) { skipped++; return; }
      pairs.push(it.variant_id + ':' + it.quantity);
      count += it.quantity;
    });
    var data = { heading: 'Warenkorb teilen', title: 'Mein Warenkorb bei ' + SHOP_NAME };
    if (pairs.length) {
      data.url = ORIGIN + '/cart/' + pairs.join(',');
      data.text = data.title + ' (' + count + ' Artikel' + ')';
    }
    if (skipped) data.note = CART_NOTE + (pairs.length ? '' : ' Der Warenkorb enthält nur konfigurierte Artikel.');
    if (!pairs.length && !skipped) data.note = 'Der Warenkorb ist leer.';
    return data;
  }

  function mountCartButton() {
    if (document.querySelector('[data-cx-share="cart"]')) return;
    var checkout = document.querySelector('.cart-form [name="checkout"]');
    var host = checkout || document.querySelector('.cart-form') || document.querySelector('.cart-order__recap');
    if (!host) return;
    var btn = el('button', 'cx-share cx-share--cart',
      '<svg role="presentation" fill="none" focusable="false" stroke-width="1.5" width="15" height="17" viewBox="0 0 16 18"><path d="M5.50006 7L10.0166 4.29005M5.50006 10L10.0166 12.7099M10.0166 4.29005C10.1604 5.53412 11.2174 6.5 12.5 6.5C13.8807 6.5 15 5.38071 15 4C15 2.61929 13.8807 1.5 12.5 1.5C11.1193 1.5 10 2.61929 10 4C10 4.09811 10.0057 4.19489 10.0166 4.29005ZM10.0166 12.7099C10.0057 12.8051 10 12.9019 10 13C10 14.3807 11.1193 15.5 12.5 15.5C13.8807 15.5 15 14.3807 15 13C15 11.6193 13.8807 10.5 12.5 10.5C11.2174 10.5 10.1604 11.4659 10.0166 12.7099ZM6 8.5C6 9.88071 4.88071 11 3.5 11C2.11929 11 1 9.88071 1 8.5C1 7.11929 2.11929 6 3.5 6C4.88071 6 6 7.11929 6 8.5Z" stroke="currentColor" stroke-linejoin="round"></path></svg>' +
      '<span class="cx-share__label">Warenkorb teilen</span>');
    btn.type = 'button';
    btn.setAttribute('data-cx-share', 'cart');
    btn.setAttribute('aria-haspopup', 'dialog');
    btn.setAttribute('aria-expanded', 'false');
    if (checkout) {
      /* hinter Checkout UND den Express-Buttons (Google Pay / PayPal), die direkt darauf folgen */
      var anchor = checkout;
      while (anchor.nextElementSibling && anchor.nextElementSibling.matches('.checkout__spacer, .additional-checkout-buttons, [data-shopify="dynamic-checkout-cart"]')) anchor = anchor.nextElementSibling;
      anchor.insertAdjacentElement('afterend', btn);
    } else {
      host.appendChild(btn);
    }

    btn.addEventListener('click', function () {
      if (pop && popOwner === btn) return closePopover();
      btn.classList.add('is-busy');
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var data = cartShareData(cart);
          if (!data.url) return openPopover(btn, data);
          if (data.note) return openPopover(btn, data); /* mit Hinweis immer Popover, damit der Hinweis sichtbar ist */
          share(btn, data);
        })
        .catch(function () { toast('Warenkorb konnte nicht geladen werden'); })
        .then(function () { btn.classList.remove('is-busy'); });
    });
  }

  function initCart() {
    if (!/^\/([a-z]{2}(-[a-z]{2})?\/)?cart\/?$/i.test(location.pathname)) return;
    mountCartButton();
    /* Das Theme rendert die Zusammenfassung bei Mengenänderung neu → Button bei Bedarf erneut setzen */
    var root = document.querySelector('.cart-order') || document.body;
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(mountCartButton, 150);
    }).observe(root, { childList: true, subtree: true });
  }

  /* ---------------- Start ---------------- */

  function init() {
    var pdp = document.querySelector('[data-cx-share="product"]');
    if (pdp) initProduct(pdp);
    initCart();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
